import React from "react";

interface CakeIconProps {
  className?: string;
  size?: number;
  color?: string;
}

export const CakeIcon: React.FC<CakeIconProps> = ({
  className = "",
  size = 18,
  color,
}) => {
  const stroke = color ?? "#6D28D9";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_22_13847)">
        <path
          d="M9 5.0625V6.75"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.375 6.75H14.625C14.9234 6.75 15.2095 6.86853 15.4205 7.07951C15.6315 7.29048 15.75 7.57663 15.75 7.875V9.51539C15.75 10.7416 14.7888 11.778 13.5633 11.8118C13.2626 11.8203 12.9632 11.7683 12.683 11.6591C12.4027 11.5499 12.1471 11.3855 11.9315 11.1758C11.7158 10.9661 11.5444 10.7153 11.4273 10.4382C11.3103 10.1611 11.25 9.86332 11.25 9.5625C11.25 10.1592 11.0129 10.7315 10.591 11.1535C10.169 11.5754 9.59674 11.8125 9 11.8125C8.40326 11.8125 7.83097 11.5754 7.40901 11.1535C6.98705 10.7315 6.75 10.1592 6.75 9.5625C6.75012 9.86338 6.68989 10.1612 6.57288 10.4384C6.45587 10.7156 6.28446 10.9665 6.06878 11.1763C5.8531 11.3861 5.59753 11.5505 5.3172 11.6597C5.03687 11.769 4.73747 11.821 4.43672 11.8125C3.21117 11.778 2.25 10.7416 2.25 9.51539V7.875C2.25 7.57663 2.36853 7.29048 2.5795 7.07951C2.79048 6.86853 3.07663 6.75 3.375 6.75Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.1875 11.0319V14.0624C15.1875 14.3608 15.069 14.6469 14.858 14.8579C14.647 15.0689 14.3609 15.1874 14.0625 15.1874H3.9375C3.63913 15.1874 3.35298 15.0689 3.142 14.8579C2.93103 14.6469 2.8125 14.3608 2.8125 14.0624V11.0319"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.6875 3.375C10.6875 3.82255 10.5097 4.25178 10.1932 4.56824C9.87678 4.88471 9.44755 5.0625 9 5.0625C8.55245 5.0625 8.12322 4.88471 7.80676 4.56824C7.49029 4.25178 7.3125 3.82255 7.3125 3.375C7.3125 1.6875 9 0.5625 9 0.5625C9 0.5625 10.6875 1.6875 10.6875 3.375Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_22_13847">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
